// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (min-width: 900px) and (max-width: 4000px) {

  .guest-box {
    min-width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .guest-wrapper {
    min-width: 880px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Guest/guest.css"],"names":[],"mappings":"AAAA;;EAEE;IACE,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":["@media (min-width: 900px) and (max-width: 4000px) {\n\n  .guest-box {\n    min-width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .guest-wrapper {\n    min-width: 880px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
